













import Vue from 'vue';

// Adapted from https://samherbert.net/svg-loaders/
export default Vue.extend({});
